export default {
  推荐好友加入: `Refer Friends &`,
  赢取巴塞罗那VIP之旅:'Win A <span class="vipWord">VIP</span> Trip To Barcelona ',

  成为EBC推荐官: "There’s no better time to welcome your friends to EBC Financial Group, where you’ll find a better way to trade.",
  立即参与: "Refer Now",
  专属奖励等你拿: "Exclusive Reward For You",
  您将获得以下奖励:'Refer 66 friends to us by 23 May 2025 and unlock the following rewards:',
  西班牙巴塞罗那之旅:'An all-expenses-paid trip to Barcelona, Spain',
  巴塞罗那足球俱乐部主场比赛VIP门票:' VIP tickets to an FC Barcelona home match',
  巴塞罗那足球俱乐部专属晚宴:'Access to an exclusive FC Barcelona gala dinner ',
  往返机票酒店住宿当地接送导服务:'Roundtrip flights, hotel accommodation & ground tours included  ',
  如何赢取大奖:'How to Win?',
  登录EBC用户中心: "Log in to EBC User Centre",
  "进入“大赛推荐官”活动页面": 'Go to the "Contest Referrer" event page',
  生成您的邀请链接或二维码: "Generate your unique invitation link or QR code",
  成功推荐66人: "Reach 66 successful referrals",
  成功推荐奖励:'Successful referees must deposit at least $500 and complete at least one trade with EBC during campaign period',
  你还在等什么:'What are YOU waiting for?',
  EBC为交易者捉供更低点差:'Refer today! EBC welcomes traders to join our superior platform with low spread, competitive money-back guarantee and many more perks. And we certainly hope to welcome YOU in Barcelona!  ',
  每一次推荐: "Every referral is a golden assist on your way to FC Barcelona.",
  参与规则: "How to Participate:",
  成为EBC推荐官并邀请66人: "Become an EBC Referral and invite 66 friends;",
  所有被邀请人均入金大于等于$500: `Each invite must deposit at least $500 and complete a trade.`,
  参与方法: "How to Join:",
  立即推荐:
    "Start referring now and celebrate legendary moments with your friends.",
  巴萨荣耀之旅: "The Champion's Road to FC Barcelona",
  每笔订单都是攻守博弈的艺术: `Every trade is a delicate balance of attack and defence. Every decision you make can be a game-changing goal in the markets. Pride, glory, and an unforgettable FC Barcelona experience await the victors of EBC's Million Dollar Trading Challenge.`,
  活动时间: "Event Duration:",
  "2025年2月22日":
    "22 February 2025, 01:00:00 (MT4/MT5 time) - 23 May 2025, 23:59:59 (MT4/MT5 time)",
  活动规则: "Event Rules",
  ruleList: [
    "This event does not conflict with normal referral rewards and other activities.",
    "The invitee needs to complete the deposit and transaction. Third-party transfers are invalid.",
    "Referral rewards apply only to compliant traders. EBC reserves the right to revoke bonuses for any violations.",
    "Accounts registered through referral are not allowed to transfer agents.",
    "The award is subject to valid account activation, VIP viewing seats include air tickets and accommodation.",
    "EBC Financial Group reserves the right to make the final decision of this event.",
  ],
};
